import BreadCrumbs from "../../Utils/Common/Breadcrumb";
import PhysicianSignatureGrid from "./PhysicianSignatureGrid";

const PhysicianSignature = () => {
  return (
    <>
      <div className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
        </div>
      </div>
      <PhysicianSignatureGrid />
    </>
  );
};

export default PhysicianSignature;
